import { useEffect, useRef, useState } from 'react';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navRef = useRef<HTMLElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { label: '레슨', href: '#lessons' },
    { label: '소개', href: '#about' },
    { label: '커리큘럼', href: '#curriculum' },
    { label: '가격', href: '#pricing' },
    { label: '오시는 길', href: '#location' },
    { label: '문의', href: '#inquiry' },
  ];

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <nav
      ref={navRef}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-studio-black/95 backdrop-blur-md border-b border-studio-border'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-6 md:px-12 lg:px-16 py-4 flex items-center justify-between">
        {/* Logo */}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="flex items-center gap-2 cursor-pointer"
        >
          <div className="w-8 h-8 flex items-center justify-center">
            <i className="ri-equalizer-line text-white text-xl" />
          </div>
          <span className="font-bebas text-white text-2xl md:text-3xl tracking-wider">
            TROUBLE <span className="text-studio-silver">STUDIO</span>
          </span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-8">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNavClick(link.href)}
              className="text-studio-silver hover:text-white font-sans text-sm font-medium transition-colors cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNavClick('#inquiry')}
            className="bg-white text-studio-black font-sans text-sm font-bold px-5 py-2 rounded-md hover:bg-studio-light transition-colors cursor-pointer whitespace-nowrap"
          >
            상담 신청
          </button>
        </div>

        {/* Mobile hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-white text-2xl`} />
        </button>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="md:hidden bg-studio-black/98 border-t border-studio-border px-6 py-6 flex flex-col gap-4">
          {navLinks.map((link) => (
            <button
              key={link.label}
              onClick={() => handleNavClick(link.href)}
              className="text-studio-silver hover:text-white font-sans text-base font-medium text-left transition-colors cursor-pointer"
            >
              {link.label}
            </button>
          ))}
          <button
            onClick={() => handleNavClick('#inquiry')}
            className="bg-white text-studio-black font-sans text-sm font-bold px-5 py-3 rounded-md hover:bg-studio-light transition-colors cursor-pointer whitespace-nowrap mt-2"
          >
            상담 신청
          </button>
        </div>
      )}
    </nav>
  );
}